import axios from 'axios';

class ShipmentService {
  async sentShipmentStatus({
    shipmentId,
    trackingNumber,
    milestone,
  }: {
    shipmentId: string;
    trackingNumber: string;
    milestone: string;
  }) {
    const response = await axios.post<any>(
      'https://dev.api.stampfree.ai/royal-mail/tracking-webhook',
      {
        shipmentId,
        trackingNumber,
        milestone,
      },
      {
        headers: {
          Authorization: 'Basic dGVzdDpUZXN0QDEyMw==',
        },
      }
    );
    return response.data;
  }
}

export const shiptmentService = new ShipmentService();
